import { IConfigsType } from '../../types'

const drgConfig: IConfigsType = {
  drg: {
    '/:brand/systemwide_overview': {
      groupFilter: {
        api: 'drgGroupFilter',
      },
      dateFilter: {
        types: [
          'week',
          'period',
          'quarter',
          'year',
          'last_week',
          'this_week',
          'yesterday',
          'trailing_7_days',
        ],
      },
      systemwideOverview: {
        type: 'list',
        api: 'systemwideOverviewKpis',
        title: 'Systemwide Overview',
        fieldWidth: '120px',
        fields: [
          {
            content: {
              key: 'netSales',
            },
            bottom: 'Total Sales',
          },
          {
            content: {
              key: 'netSalesSssPercent',
              decimal: 1,
            },
            bottom: 'SSS %',
          },
          {
            content: {
              key: 'netSalesBudgetVariance',
              decimal: 1,
            },
            bottom: 'Net Sales Budget Variance',
          },
          {
            content: {
              key: 'checkCount',
            },
            bottom: 'Check Count',
          },
          {
            content: {
              key: 'checkAverage',
              decimal: 2,
            },
            bottom: 'Check Average',
          },
          {
            content: {
              key: 'checkCountLy',
            },
            bottom: 'YoY Check Count',
          },
          {
            content: {
              key: 'checkCountVsLyPercent',
              decimal: 1,
            },
            bottom: 'Check Count % vs LY',
          },
          {
            content: {
              key: 'checkAverageLy',
              decimal: 2,
            },
            bottom: 'YoY Check Average',
          },
          {
            content: {
              key: 'checkAverageLyPercent',
              decimal: 1,
            },
            bottom: 'Check Average % vs LY',
          },
          {
            content: {
              key: 'hourlyLaborCostPercent',
              decimal: 1,
            },
            bottom: 'Hourly Labor Percent',
          },
          {
            content: {
              key: 'hourlyLaborBudgetVariance',
              decimal: 1,
              color: '<%- value > 0 ? colors.Pomodoro : "" %>',
            },
            bottom: 'Hourly Labor Budget Variance',
          },
          {
            content: {
              key: 'avtPercent',
              decimal: 1,
            },
            bottom: 'AvT',
          },
          {
            content: {
              key: 'cogsPercent',
              decimal: 1,
            },
            bottom: 'COGS',
          },
          {
            content: {
              key: 'cogsBudgetVariance',
              decimal: 1,
              color: '<%- value > 0 ? colors.Pomodoro : "" %>',
            },
            bottom: 'COGS Budget Variance',
          },
          {
            content: {
              key: 'rcpPercent',
              decimal: 1,
            },
            bottom: 'RCP',
          },
        ],
      },
      breakdownByStore: {
        type: 'table',
        api: 'systemwideOverview',
        title: 'Breakdown by Store',
        pageSize: 20,
        defaultSortedField: 'netSales',
        groupInfo: {
          width: '200px',
          groupBy: {
            width: '200px',
          },
        },
        columns: [
          {
            key: 'Sales',
            title: 'Net Sales',
            align: 'center',
            highlight: true,
            children: [
              {
                key: 'netSales',
                title: '$',
                align: 'center',
                sortable: true,
              },
              {
                key: 'netSalesBudgetVariance',
                title: 'Variance',
                align: 'center',
                decimal: 1,
                sortable: true,
              },
              {
                key: 'netSalesSssPercent',
                title: 'SSS %',
                align: 'center',
                decimal: 1,
                sortable: true,
              },
            ],
          },
          {
            key: 'Checks',
            title: 'Checks',
            align: 'center',
            children: [
              {
                key: 'inUnitYoyCheckCount',
                title: 'YoY Check Count',
                align: 'center',
                sortable: true,
              },
              {
                key: 'inUnitYoyCheckCountGrowth',
                title: 'Check Count % vs LY',
                align: 'center',
                sortable: true,
              },
            ],
          },
          {
            key: 'Labor',
            title: 'Hourly Labor',
            align: 'center',
            children: [
              {
                key: 'hourlyLaborCostPercent',
                title: '%',
                align: 'center',
                decimal: 1,
                sortable: true,
              },
              {
                key: 'hourlyLaborBudgetVariance',
                title: 'Variance',
                align: 'center',
                decimal: 1,
                reverse: true,
                sortable: true,
              },
            ],
          },
          {
            key: 'COGS',
            title: 'COGS',
            align: 'center',
            highlight: true,
            children: [
              {
                key: 'cogsPercent',
                title: '%',
                align: 'center',
                sortable: true,
                decimal: 1,
              },
              {
                key: 'cogsBudgetVariance',
                title: 'Variance',
                align: 'center',
                reverse: true,
                sortable: true,
                decimal: 1,
              },
              {
                key: 'avtPercent',
                title: 'AvT',
                align: 'center',
                sortable: true,
                decimal: 1,
              },
            ],
          },
          {
            key: 'RCP',
            title: 'RCP',
            align: 'center',
            children: [
              {
                key: 'rcp',
                title: '$',
                align: 'center',
                sortable: true,
              },
              {
                key: 'rcpPercent',
                title: '%',
                align: 'center',
                sortable: true,
                decimal: 1,
              },
              {
                key: 'rcpBudgetVariance',
                title: 'Variance',
                align: 'center',
                sortable: true,
                decimal: 1,
              },
            ],
          },
        ],
      },
      map: {
        type: 'map',
        api: 'listGeoInfo',
      },
      feV2ChatBox: {
        type: 'feV2-chatbox',
        hideFromNonExpoUsers: false,
        disableInputField: false,
        sendStoreId: false,
        useThinking: true,
        description: 'Ask about sales performance',
        bubblePrompts: [
          {
            id: 'sales',
            label: 'Sales',
            prompt: 'Show me the sales performance',
            children: [
              {
                id: 'yesterday',
                label: 'Yesterday',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'yesterday',
                },
                prompt: 'yesterday',
              },
              {
                id: 'sales_7days',
                label: '7 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_7days',
                },
                prompt: 'over the past 7 days',
              },
              {
                id: 'sales_30days',
                label: '30 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_30days',
                },
                prompt: 'over the past 30 days',
              },
              {
                id: 'sales_90days',
                label: '90 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_90days',
                },
                prompt: 'over the past 90 days',
              },
            ],
            agentCode: 'prompt:sales',
          },
          {
            id: 'daypart',
            label: 'Day Part',
            prompt: 'Show me the sales performance by day part',
            children: [
              {
                id: 'yesterday',
                label: 'Yesterday',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'yesterday',
                },
                prompt: 'yesterday',
              },
              {
                id: 'daypart_7days',
                label: '7 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_7days',
                },
                prompt: 'over the past 7 days',
              },
              {
                id: 'daypart_30days',
                label: '30 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_30days',
                },
                prompt: 'over the past 30 days',
              },
              {
                id: 'daypart_90days',
                label: '90 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_90days',
                },
                prompt: 'over the past 90 days',
              },
            ],
            agentCode: 'prompt:sales-daypart',
          },
          {
            id: 'revenue-center',
            label: 'Revenue Center',
            prompt: 'Show me the sales performance by revenue center',
            children: [
              {
                id: 'yesterday',
                label: 'Yesterday',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'yesterday',
                },
                prompt: 'yesterday',
              },
              {
                id: 'revenue-center_7days',
                label: '7 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_7days',
                },
                prompt: 'over the past 7 days',
              },
              {
                id: 'revenue-center_30days',
                label: '30 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_30days',
                },
                prompt: 'over the past 30 days',
              },
              {
                id: 'revenue-center_90days',
                label: '90 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_90days',
                },
                prompt: 'over the past 90 days',
              },
            ],
            agentCode: 'prompt:sales-revenue-center',
          },
        ],
      },
    },
  },
}

export default drgConfig
